module.exports = __webpack_public_path__ + "img/certi.828b7513.svg";